module.exports = __webpack_public_path__ + "img/doug-yourcarsold-car-buyers-dealers-rivervale-perth-wa.e39a11ac.jpg";